import React from 'react';
import Modal from 'react-modal';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation, Pagination } from "swiper";
import 'swiper/scss'
import 'swiper/scss/navigation'
import 'swiper/scss/pagination'
import "./SwiperStyles.scss";
import {IVehicleSearch} from "../../interfaces/VehicleSearch";
import {translateService} from "../../services/TranslateService";

interface VehicleImageSwiperProps {
    vehicle: IVehicleSearch;
}

interface ImageSwiperProps {
    isCardResult: boolean;
    width?: number;
    height?: number;
}

const customStyles = {
    content: {
        width: 'auto',
        minWidth: '200px',
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        backgroundColor: 'rgba(0,0,0,0.7)',
        color: 'white',
    },
    overlay: {
        zIndex: '20',
    },
};

SwiperCore.use([Navigation, Pagination]);

export function VehicleImageSwiper (props: VehicleImageSwiperProps) {
    let vehicleImagesArray: string[] = [] ;
    const [viewImageLarge, setViewImageLarge] = React.useState<boolean>(false);

    if( props.vehicle.vehicleImages ) {
        props.vehicle.vehicleImages.forEach((image: any) => {
            let imageNames = image.imageName.replace("jpeg", "webp");
            vehicleImagesArray.push(imageNames);
        })

        if(!vehicleImagesArray.length) {
            // this handles any errors for empty strings from data
            vehicleImagesArray.push(props.vehicle.id + '_medium.jpeg')
        }
    } else {
        vehicleImagesArray.push(props.vehicle.id + '_medium.jpeg')
    }

    function ImageSwiper (swiperProps: ImageSwiperProps) {
        let imageAlt = props.vehicle.vehicleModelData.manufacturer +
            props.vehicle.vehicleModelData.name +
            (props.vehicle.vehicleModelData.dimensions.trunkVolume !== 0 ?
                props.vehicle.vehicleModelData.dimensions.trunkVolume + ' m³' : '')
        const [activeImageIndex, setActiveImageIndex] = React.useState(0);

        return(
            <Swiper
                onSwiper={() => {}}
                spaceBetween={0}
                slidesPerView={1}
                navigation={vehicleImagesArray.length > 1}
                pagination={{ clickable: true }}
                onSlideChange={() => { }}
                onRealIndexChange={(e) => {setActiveImageIndex(e.realIndex)}}
                touchRatio={0} // removes drag ability
                loop={true}
                className={"VSComponent-swiperContainer"}
                style={{
                    width: window.innerWidth > 767 ? (swiperProps.width ?? 243) : '300px',
                    height: window.innerWidth > 767 ? (swiperProps.height ?? 162) : '200px'
                }}>
                { vehicleImagesArray.map((image, imageNum) => (
                        <SwiperSlide key={imageNum} className="VSComponent-swiperSlide" >
                            { activeImageIndex === imageNum ?
                                viewImageLarge ?
                                    <img
                                        width="600" height="400" 
                                        className={"VSComponent-carImage"}
                                        alt={imageAlt}
                                        src={"https://vehicles-cdn.24rent.fi/" + image.replace("large", "mediumplus")}
                                    />
                                    : 
                                    <img
                                        width="243" height="162" 
                                        className={"VSComponent-carImage"}
                                        alt={imageAlt}
                                        onClick={() => {if (swiperProps.isCardResult) {setViewImageLarge(true)}}}
                                        src={"https://vehicles-cdn.24rent.fi/" + image.replace("large", "medium")}
                                    />
                                : null
                            }
                        </SwiperSlide>
                    ))
                }
            </Swiper>
        )
    }

    return (
        <div className={"VSComponent-imageSwiper"}>
            <Modal isOpen={viewImageLarge} style={customStyles}>
                <ImageSwiper isCardResult={false} width={600} height={400}/>
                <button onClick={(e) => {setViewImageLarge(false)}}
                        className="btn btn-primary btn-outline-primary mt-2 w-100 ">
                    {translateService.translate("vehicleSearch1.closeVehicleImageModal")}
                </button>
            </Modal>
            <ImageSwiper isCardResult={true}/>
        </div>
    )

}